import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { frontloadConnect } from 'react-frontload';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {t} from 'l10n';

import {getBobstoreProductsOwned} from "reducers/memberBobstoreProductsOwned";

import ItemSelect from './ItemSelect';

import '../../sass/form/bobstore-product-select.scss';

class BobstoreProductSelect extends Component
{
    constructor(props) {
        super(props);

        this.selectProduct = this.selectProduct.bind(this);
        this.state = {product: "0", loading: true}
        
    }

    selectProduct(product) {
        this.setState({product: product.nid});
    }

    renderProduct(product) {
        return (<div className="product" key={product.nid}>
                    <abbr title={product.title}>
                    <div className="thumbnail" key={product.nid} style={ { backgroundImage: 'url(' + product.uc_product_image[0].original + ')'} }/>
                    <div className="title">{product.title}</div>
                    </abbr>
                </div>);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.products.isLoading && !this.props.products.isLoading) {
            if (this.props.onLoad) this.props.onLoad(this.props.products);
            this.setState({loading: false})
        }
    }

    renderLoading() {
        return (<div>{t('Please wait...')}</div>);
    }

    render() {
        //let products = Object.values(this.props.products.list);
        
        let products = [];
        let renderedProducts = [];
        for (const productKey in this.props.products.list) {
            let product = this.props.products.list[productKey].product;
            products.push(product);
        }

        products.sort( (a, b) => { return b.received - a.received; } );

        for (const productKey in products) {
            let product = products[productKey];

            renderedProducts.push(this.renderProduct(product));
        }

        if (this.state.loading) return this.renderLoading();
        let classes = "forms-select forms-bobstore-product-select";
        if (products.length > 15) {
            classes += " scroll";
        }
        return (

            <div className={classes}>
                <ItemSelect items={renderedProducts} name={this.props.name}/>
            </div>
        )
    }
}

BobstoreProductSelect.fetchData = function( { dispatch } ) {
  return dispatch(getBobstoreProductsOwned({  }))
}

BobstoreProductSelect.propTypes = {
    name: PropTypes.string.isRequired
};


const frontloadFunction = async (props) => {
  const {dispatch} = props;
  await BobstoreProductSelect.fetchData({ dispatch });
};

const mapStateToProps = (state, ownProps) => {
  return { products: state.memberBobstoreProductsOwned };
};

export default compose(
    withRouter,
    connect(mapStateToProps),
    frontloadConnect(frontloadFunction)
)(BobstoreProductSelect)



// WEBPACK FOOTER //
// ./src/components/form/BobstoreProductSelect.js